import { usePersistingActor } from '@ui-common/hooks/usePersistingActor'
import { createContext, JSX, ReactNode, useMemo } from 'react'
import { ActorRefFrom } from 'xstate'

import { createWizardMachine, initialSecLoansWizardContext, WizardContext } from '../wizard/wizardMachine'

interface ApplicationWizardContext {
  service: ActorRefFrom<ReturnType<typeof createWizardMachine>>
}

export const ApplicationWizardContext = createContext<ApplicationWizardContext>({} as ApplicationWizardContext)

interface Props {
  children: ReactNode
  initialContext?: Partial<WizardContext>
}

export const ApplicationWizardProvider = ({ children, initialContext }: Props): JSX.Element => {
  const wizardMachine = createWizardMachine()
  const service = usePersistingActor(wizardMachine, undefined, undefined, {
    ...initialSecLoansWizardContext,
    ...initialContext,
  })
  const context = useMemo(() => ({ service }), [service])
  return <ApplicationWizardContext value={context}>{children}</ApplicationWizardContext>
}
